<template>
	<div class="fuel container-fluid py-2">
		<router-view @childrenRoute="hideNonChildren" />
		<div class="row" v-if="!isChildRoute">
			<div class="col-md-12 pl-0">
				<div class="row">
					<div class="col-md-6 ">
						
					</div>
				</div>
			</div>

		</div>
		<Footer/>
	</div>
</template>

<script>
import Fuel from '@/components/page/Fuel.js'
import BarCard from '@/views/pages/BarCard.vue'
import ListItem from '@/views/pages/ListItem.vue'
import ListCompare from '@/views/pages/ListCompare.vue'
import Footer from '@/views/Footer.vue'
import PieChart from '@/components/chart/Pie.js'

export default{
	extends: Fuel,
	components:{
		//PieChart,         
	},

	data() {
		return {
			isChildRoute: false,
            //pieChartDataPayment : [],
		}
	},

	watch : {
		$route(to, from) {
            this.hideNonChildren();
        }
	},

	computed:{
		
	},

    mounted() {
		this.hideNonChildren();
    },
    methods:{
		hideNonChildren() {
            this.isChildRoute = this.$route.path !== '/business-tracking';
        },
	}
}
</script>